import { useState } from 'react';
import { Form, Header, Input, Button } from 'semantic-ui-react'
import { notify } from 'react-notify-toast';
import useUser from '../../Shared/UserProvider/useUser';
import { useTranslation } from 'react-i18next';
import { updateSelf } from '../../../services/User/User.service';
import { useMutation } from '@tanstack/react-query'

const UserForm = () => {
    const [t] = useTranslation();

    const {user, setUser} = useUser();

    const [firstname, setFirstname] = useState(user.firstname)
    const [lastname, setLastname] = useState(user.lastname)

    const updateSelfMutation = useMutation({
        mutationFn: async ({ firstname, lastname }) => await updateSelf({
            firstname,
            lastname
        }),
        onMutate: () => {
            setUser(prev => ({
                ...prev,
                firstname: user.firstname,
                lastname: user.lastname
            }))
        },
        onSuccess: (data, variables) => {
            setFirstname(data.firstname)
            setLastname(data.lastname)
            notify.show(t('global.registerSuccess'), 'success');
        },
        onError: () => {
            notify.show(t('global.anErrorOccurred'), 'error');
        },
    })

    return (
        <Form>
            <Header>{t('administration.users.user_header')}</Header>
            <Form.Field
                control={Input}
                name="firstname"
                value={firstname}
                onChange={(evt, dt) => setFirstname(dt.value)}
                label={t('administration.users.firstname')}
                placeholder={t('administration.users.firstname')}
            />
            <Form.Field
                control={Input}
                name="lastname"
                value={lastname}
                onChange={(evt, dt) => setLastname(dt.value)}
                label={t('administration.users.lastname')}
                placeholder={t('administration.users.lastname')}
            />

            <div style={{ textAlign: 'right' }}>
                <Button
                  color="teal"
                  type="submit"
                  loading={updateSelfMutation.isPending}
                  disabled={updateSelfMutation.isPending}
                  onClick={() => updateSelfMutation.mutate({
                      firstname,
                      lastname
                  })}>{t('global.save')}
                </Button>
            </div>
        </Form>
    )
}

export default UserForm
